<template>
  <b-form-group label="Distribuidor">
    <div class="form-inline">
        <b-form-input readonly @input="$emit('input', $event.target.value);"  ref="input" class="col-sm-2 mr-1" type="text" :name="name" :value="id" placeholder="ID Distribuidor":state="state" ></b-form-input>
        <b-form-input   class="col-md-6 col-sm-5 mr-1" type="text" name="dealer"  :value="name" :placeholder="'Distribuidor'" readonly ></b-form-input>
        <b-button v-if="!readonly"  class="col-md-3 col-sm-4"  variant="success" @click="doShowModal()">selecionar</b-button>
    </div>
    <b-modal no-enforce-focus @shown="showModal=true" @hidden="showModal=false" size="lg"  ref="selectorModal" >
      <modal v-if="showModal" height="400" v-on:select-item="itemSelected" />
    </b-modal>
  </b-form-group>
</template>

<script>
import Modal from './modal.vue'
export default {
  name: 'DealersModalInput',
  $_veeValidate: {
    // value getter
    value() {
      return this.id;
    },
    // name getter
    name() {
      return this.name;
    }
  },
  props: ['name', 'state', 'itemId', 'itemName', 'readonly'],
  components: { Modal },
  data() {
    return {
      showModal: false,
      id: null,
      aname: null
    }
  },
  methods: {
    itemSelected(e) {
      this.id = e.item.id
      this.aname = e.item.name
      this.$emit('select-item', {
        item: e.item
      })
      this.$emit('input', this.id)
      this.hideModal()
    },
    doShowModal() {
      this.$refs.selectorModal.show()
    },
    hideModal() {
      this.$refs.selectorModal.hide()
    }
  },
  created() {
    this.id = typeof this.itemId == 'undefined' ? '': this.itemId
    this.$refs.input.value = this.id;
    this.aname = this.itemName
  }
}
</script>
